import { Box, Icons, Text } from '@vouched.id/vault';
import React from 'react';
import { AMLCaption } from 'components/account/jobs-v2/dropdowns/AML/AMLCaption';
import { AMLDropdowns } from 'components/account/jobs-v2/dropdowns/AML/AMLDropdowns';
import { AmlV2Dropdowns } from 'components/account/jobs-v2/dropdowns/AML/AmlV2Dropdowns';
import { Dropdown } from 'components/account/jobs-v2/dropdowns/Dropdown';
export const AmlPageSwitch = ({ amlV2, isAMLOnly, jobAMLResults, jobErrors, jobSid, jobStatus }) => {
    if (amlV2 === 'pending' || amlV2 === 'failed')
        return (React.createElement(Dropdown, { title: "AML" },
            React.createElement(Box, null,
                React.createElement(AMLCaption, null),
                amlV2 === 'failed' ? (React.createElement(Text, null, "AML results could not be loaded. Please refresh the page or contact support.")) : (React.createElement(Icons.Loading, null)))));
    return amlV2.version === 'v1' ? (React.createElement(AMLDropdowns, { isAMLOnly: isAMLOnly, jobAMLResults: jobAMLResults, jobErrors: jobErrors, jobSid: jobSid, jobStatus: jobStatus })) : (React.createElement(AmlV2Dropdowns, { job: amlV2, jobStatus: jobStatus }));
};
